import { Route, useLocation, Routes } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
import LoadingPage from './components/global/LoadingPage';

import NavBar from './components/NavBars';
import Footer from './components/Footer/footers/Footer';
import ScrollToTopButton from './components/global/ScrollToTopButton';
import { useBasicData } from './hooks/useBasicData';
import { Helmet } from 'react-helmet-async';
import NotFound from './pages/NotFound';
import ProductsTractor from './pages/productTractor';
import Category from './pages/Category';
// import ProductsTractorFade from './pages/productTractorFade';
// import DownloadBrochure from './components/global/DownloadBrochure';

// Pages

const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/About"));
const Events = lazy(() => import("./pages/Events"));
const Event = lazy(() => import("./pages/Event"));
// const Products = lazy(() => import("./pages/Products"));
const Categories = lazy(() => import("./pages/Categories"));
const Product = lazy(() => import("./pages/Product"));
// const OurBlogs = lazy(() => import("./pages/OurBlogs"));
// const Blog = lazy(() => import("./pages/Blog"));
const ContactUs = lazy(() => import("./pages/ContactUs"));

const RoutesPath = () => {
    const { basicData } = useBasicData()

    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);
        return null;
    };
    return (
        <>
            <Helmet>
                <title>{basicData?.data?.name}</title>
                <link rel="icon" href={basicData?.data?.favIcon} />
                <meta name="description" content={basicData?.data?.footerBio} />
                <link rel="apple-touch-icon" href={basicData?.data?.favIcon} />
            </Helmet>
            <NavBar />
            {/* <DownloadBrochure /> */}
            <ScrollToTop />
            <ScrollToTopButton whatsApp={basicData?.data?.whatsappNumber}/>
            <Suspense fallback={<LoadingPage />}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<AboutUs />} />
                    {/* <Route path="/products" element={<ProductsTractorFade />} /> */}
                    {/* <Route path="/products" element={<Products />} /> */}
                    <Route path="/products" element={<ProductsTractor />} />
                    <Route path="/categories/:catSlug" element={<Category />} />
                    <Route path="/products/:slug" element={<Categories />} />
                    <Route path="/product/:productSlug" element={<Product />} />
                    <Route path="/events" element={<Events />} />
                    <Route path="/event/:eventSlug" element={<Event />} />
                    {/* <Route path="/blogs" element={<OurBlogs />} />
                    <Route path="/blogs/:blogSlug" element={<Blog />} /> */}
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
            <Footer basicData={basicData}/>
        </>
    );
};

export default RoutesPath;
